module.exports = __webpack_public_path__ + "img/fm_end_signup.7307d683.png";